import { FastifyRequest } from 'fastify';
import { BASE_URL } from 'helpers/global.const.helper';

export const generateAddOpinionLink = (url: string): string => `${url?.replace('opinie', 'ocen')}?utm_source=skapiec&#zawartosc`;

export const isFrontPage = (url?: string): boolean => {
    return ((url === '') || (url === '/'));
};

export const isFullUrl = (url = ''): boolean => {
    if (!url) {
        return false;
    }

    return url.startsWith('http');
};

export const getUrl = (req: FastifyRequest, path: string): string => {
    return `${req.protocol}://${req.hostname}${path}`;
};

export const normalizeUrl = (url = ''): string => {
    return !url ? '' : `/${url.replace(/^\//, '')}`;
};

export const normalizeRedirectUrl = (req: FastifyRequest, redirectUrl: string): string => {
    return isFullUrl(redirectUrl) ? redirectUrl : getUrl(req, normalizeUrl(redirectUrl));
};

export const getFullUrl = (url = ''): string => {
    return isFullUrl(url) ? url : `${BASE_URL}${normalizeUrl(url)}`;
};

export const extractUrlSlug = (url: string, separator = '/'): string | null => {
    return url?.split(separator)?.splice(-1, 1)?.join('') ?? null;
};
